function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "animated-path",
  d: "M47.9562 42.5829L37.0226 58.4164L48.023 74.5067L58.9855 58.3803L47.9562 42.5829Z",
  fill: "#0897FE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.6616 58.4629L31.1977 58.4287L45.0228 38.3762L36.2438 25.7833L13.6616 58.4629Z",
  fill: "#0D2CCC"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.7835 58.3634L82.3238 58.3296L57.8838 23.1944L40.3446 23.2286L64.7835 58.3634Z",
  fill: "#0D2CCC"
});

var SvgLaunchIcon = function SvgLaunchIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLaunchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LaunchIcon.4d87e4b7.svg";
export { ForwardRef as ReactComponent };